module.exports = __webpack_public_path__ + "images/feature/doc-tools-b4702f58e5a7bd0af64f25430c46d3cb.jpg";